export const config = {
  api: {
    // Legacy API Gateway (invoke endpoint)
    baseUrl: 'https://zc436z6iwd.execute-api.us-east-1.amazonaws.com',
    // New API Gateway (chat + query endpoints)
    newBaseUrl: 'https://wnatdv7qzb.execute-api.us-east-1.amazonaws.com',
    lambdaUrl:
      'https://ydzoogt5b7ckbzribuzkbkiktm0zjpsz.lambda-url.us-east-1.on.aws',
    useLambdaUrl: false,
    tenantId: 'a1fbafd5',
    projectKey: 'VSM',
    sprintId: 'SPRINT-2024-01',
  },
  chat: {
    // 'agentfront' → Frontend orchestrator (OpenAI + MCP tools) — DEFAULT
    // 'chat'       → POST {newBaseUrl}/v1/agent/chat
    // 'invoke'     → POST {baseUrl}/v1/agent/invoke (legacy)
    // 'query'      → POST {newBaseUrl}/v1/agent/query
    defaultEndpoint: 'agentfront' as 'chat' | 'invoke' | 'query' | 'agentfront',
  },
  cognito: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_uNbCQjT7u',
    clientId: '60ps0o9uijosjnvim9uloiiggm',
    endpoint: 'https://cognito-idp.us-east-1.amazonaws.com/',
  },
  // Main backend API credentials (Jira MCP Cognito pool — dev branch)
  credentials: {
    username: 'test_barbus@workium.ia',
    password: 'McpJira2026#',
  },
  // GitHub credentials — PAT for direct API access
  github: {
    token: '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',
    org: '',
    // Set per-user via UserProfile.github.org
    defaultRepos: [], // Discovered dynamically via API
  },
  // AgentFront MCP credentials — separate Cognito pools for Confluence & Jira
  // These are used by mcpAuth.ts to authenticate with the MCP API Gateways
  mcpCredentials: {
    confluence: {
      username: 'test_barbus@workium.ia',
      password: 'McpJira2026#',
    },
    jira: {
      username: 'test_barbus@workium.ia',
      password: 'McpJira2026#',
    },
  },
}
